import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14b5660a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "ag" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "基本信息", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "附件", -1))
const _hoisted_9 = { class: "filebox" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "奖惩记录", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "havior" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "time" }
const _hoisted_16 = { class: "text" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "havior" }
const _hoisted_19 = { class: "content" }
const _hoisted_20 = { class: "time" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "资质证书", -1))
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "box-text" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 证书名称：")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 证书所属类型：")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 证书编号：")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 证书有限期：")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "安全教育信息", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "健康信息", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")!
  const _component_van_collapse = _resolveComponent("van-collapse")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_nav_bar, {
      style: {},
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.oBaseInfo.photoUrl,
          alt: ""
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.oBaseInfo.name), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.oBaseInfo.sex === 1 ? "男" : "女"), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_van_collapse, {
        modelValue: _ctx.one,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.one) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_collapse_item, { name: "1" }, {
            title: _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx(() => [
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_cell, {
                    title: "登录账号",
                    value: _ctx.oBaseInfo.username
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "状态",
                    value: _ctx.oBaseInfo.status === 1 ? '正常' : '禁用'
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "出生日期",
                    value: _ctx.oBaseInfo.birth
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "民族",
                    value: _ctx.oBaseInfo.nation
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "证件类型",
                    value: "身份证"
                  }),
                  _createVNode(_component_van_cell, {
                    title: "证件号码",
                    value: _ctx.oBaseInfo.idNo
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "证件有效始日期",
                    value: _ctx.oBaseInfo.idStart
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "证件有效止日期",
                    value: _ctx.oBaseInfo.idEnd
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "文化程度",
                    value: _ctx.oBaseInfo.eduLevel
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "政治面貌",
                    value: _ctx.oBaseInfo.politicalLevel
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "签发机关",
                    value: _ctx.oBaseInfo.issuingAuthority
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "户籍地址",
                    value: _ctx.oBaseInfo.liveAddress
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "本市暂住地址",
                    value: _ctx.oBaseInfo.temporaryAddress
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "手机号码",
                    value: _ctx.oBaseInfo.mobile
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "户籍所属地区",
                    value: 
                _ctx.oBaseInfo.province && _ctx.oBaseInfo.city && _ctx.oBaseInfo.qu
                  ? _ctx.oBaseInfo.province +
                    '/' +
                    _ctx.oBaseInfo.city +
                    '/' +
                    _ctx.oBaseInfo.qu
                  : ''
              
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "进场日期",
                    value: _ctx.oBaseInfo.planStart
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "离场日期",
                    value: _ctx.oBaseInfo.planEnd
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "参见单位",
                    value: _ctx.oBaseInfo.deptNames
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "部门",
                    value: _ctx.oBaseInfo.deptIdList
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "角色",
                    value: _ctx.oBaseInfo.roleNames
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "是否管理人员",
                    value: _ctx.oBaseInfo.manger === 1 ? '是' : '否'
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "岗位",
                    value: _ctx.oBaseInfo.stationName
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "班组",
                    value: _ctx.oBaseInfo.teamName
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "在场状态",
                    value: _ctx.oBaseInfo.workStatus === 1 ? '在场' : '离场'
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "工龄",
                    value: _ctx.oBaseInfo.workAge ? _ctx.oBaseInfo.workAge + '年' : ''
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, {
                    title: "备注",
                    value: _ctx.oBaseInfo.remark
                  }, null, 8, ["value"]),
                  _createVNode(_component_van_cell, null, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oBaseInfo.safeFile, (item, index) => {
                          return (_openBlock(), _createElementBlock("img", {
                            class: "fileitem",
                            src: item.url,
                            key: index
                          }, null, 8, _hoisted_10))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_van_collapse, {
        modelValue: _ctx.two,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.two) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_collapse_item, { name: "1" }, {
            title: _withCtx(() => [
              _hoisted_11
            ]),
            default: _withCtx(() => [
              _createVNode(_component_van_collapse, {
                modelValue: _ctx.award,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.award) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_collapse_item, {
                    title: "良好行为",
                    name: "1"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.aGoodHavior.length >= 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "暂无良好行为"))
                        : (_openBlock(), _createBlock(_component_van_cell_group, { key: 1 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aGoodHavior, (item, indx) => {
                                return (_openBlock(), _createBlock(_component_van_cell, {
                                  class: "block-tar",
                                  key: indx
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createElementVNode("div", _hoisted_14, _toDisplayString(item.details), 1),
                                      _createElementVNode("div", _hoisted_15, _toDisplayString(item.occurredTime), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_16, _toDisplayString(item.content), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_van_collapse, {
                modelValue: _ctx.punishment,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.punishment) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_collapse_item, {
                    title: "不良行为",
                    name: "1"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.aNoGoodHavior.length >= 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, "暂无不良行为"))
                        : (_openBlock(), _createBlock(_component_van_cell_group, { key: 1 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aNoGoodHavior, (item, indx) => {
                                return (_openBlock(), _createBlock(_component_van_cell, {
                                  class: "block-tar",
                                  key: indx
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("div", _hoisted_19, _toDisplayString(item.details), 1),
                                      _createElementVNode("div", _hoisted_20, _toDisplayString(item.occurredTime), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_21, _toDisplayString(item.content), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_van_collapse, {
        modelValue: _ctx.three,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.three) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_collapse_item, { name: "1" }, {
            title: _withCtx(() => [
              _hoisted_22
            ]),
            default: _withCtx(() => [
              (_ctx.aQualificationList.length >= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, "暂无资质证书"))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aQualificationList, (item, indx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: indx,
                        class: "box"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            src: item.fileList.length > 0 ? item.fileList[0].url : _ctx.img
                          }, null, 8, _hoisted_25)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", null, [
                            _hoisted_27,
                            _createElementVNode("span", null, _toDisplayString(item.name), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_28,
                            _createElementVNode("span", null, _toDisplayString(item.typeName), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_29,
                            _createElementVNode("span", null, _toDisplayString(item.qualificationNum), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_30,
                            _createElementVNode("span", null, _toDisplayString(item.endDate), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_van_collapse, {
        modelValue: _ctx.four,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.four) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_collapse_item, { name: "1" }, {
            title: _withCtx(() => [
              _hoisted_31
            ]),
            default: _withCtx(() => [
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainList, (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_cell, {
                      key: index,
                      title: item.trainName,
                      value: item.count +'分钟'
                    }, null, 8, ["title", "value"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_van_collapse, {
        modelValue: _ctx.five,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.five) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_collapse_item, { name: "1" }, {
            title: _withCtx(() => [
              _hoisted_32
            ]),
            default: _withCtx(() => [
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_cell, {
                    title: "健康状态",
                    value: "健康"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}